import { render, staticRenderFns } from "./CpfDuplicadoModal.vue?vue&type=template&id=11a02f2e"
import script from "./CpfDuplicadoModal.vue?vue&type=script&lang=js"
export * from "./CpfDuplicadoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports